import Axios from 'axios';
import { getRequestToken, onRequestTokenUpdate } from '@nextcloud/auth';

const client = Axios.create({
    headers: {
        requesttoken: getRequestToken() ?? ''
    }
});
const cancelableClient = Object.assign(client, {
    CancelToken: Axios.CancelToken,
    isCancel: Axios.isCancel,
});
onRequestTokenUpdate(token => client.defaults.headers.requesttoken = token);

export { cancelableClient as default };
//# sourceMappingURL=index.esm.js.map
